module.exports = __webpack_public_path__ + "img/background-landing.8e67d797.jpg";